import { useErrorContext } from '../../context/ErrorContext';
import Validation from '../../validation/Authentication/Validation.js';
import { Axios, useState, useNavigate, FaEyeSlash } from '../../common/common';
import Navigations from '../../common/useNavigation.js';
import { useEffect } from 'react';
import { showToast } from '../../Utils/toastUtils.js';

const MidForgotPassword = () => {

    const { navigateRegisteration, navigateMain, navigateOTP, navigateSellerProductAttributes, navigateUserType, navigateDashboard, navigateBuyerBusinessdetails } = Navigations();
    const navigate = useNavigate();
    const { validateForgotPasswordForm } = Validation;
    const { setValidationError, clearAllErrors } = useErrorContext();

    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(FaEyeSlash);

    const [values, setValue] = useState({ emailnmobi: ""});
    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const navigateSellerPersonaldetails = (type) => { navigate(`/Business-details/${type}`); };
    const navigateResetPassword = (token) => { navigate(`/reset-password/${token}`); };


    useEffect(() => {
        showToast('', '');
    }, [])

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateForgotPasswordForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setValue(prev => ({ ...prev, [name]: value }));
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
        }
    };
    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {

            clearAllErrors();
            checkForgotPassword();
        }
    };
    const navigateRegisterations = () => {
        setisLoading(true);
        navigateRegisteration();
    }
    const checkForgotPassword = () => {
        const { emailnmobi } = values;


        if (!emailnmobi) {
            showToast('Please fill required field Email Address', 'error');
            return;
        }

        setisLoading(true);
        setisDisabled(true);

        Axios.post(`${process.env.REACT_APP_API_URL}/api/authForgotPassword`, { Emailmobile: emailnmobi, app: 0 }, { withCredentials: true })
            .then(handleForgotPasswordResponse)
            .catch(handleForgotPasswordError);
    };

    const handleForgotPasswordResponse = (res) => {
        const result = res.data;
        if (result.success === 1) {
           showToast(result.message, 'success');
           clearForm();
        }
        else {
            showToast(result.message, 'error');
        }

        resetLoadingState();
    };

    const handleForgotPasswordError = (err) => {
        // console.error(err);
        showToast(err.response?.data?.message || err.message || "An error occurred", 'error');
        resetLoadingState();
    };
    const resetLoadingState = () => {
        setisLoading(false);
        setisDisabled(false);
    };

    const clearForm = () => {
        values.emailnmobi = '';
    };

    const handleToggle = () => {
        if (type === 'password') { setType('text'); }
        else { setType('password'); }
    }

    return { handleSubmit, handleChange, values, type, setType, icon, setIcon, handleToggle, isLoading, setisLoading, isDisabled, setisDisabled, useErrorContext, navigateRegisterations };
};

export default MidForgotPassword;
